import React, { useEffect, useState } from 'react';
import { Fab, Tooltip } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';
import { settingsService } from '../../services/firebase';

const WhatsAppButton: React.FC = () => {
  const [phoneNumber, setPhoneNumber] = useState('+905555555555');
  const message = 'Merhaba! Tur paketleri hakkında bilgi almak istiyorum.';

  useEffect(() => {
    const fetchNumber = async () => {
      try {
        const settings = await settingsService.getSettings();
        if (settings?.whatsappNumber) {
          setPhoneNumber(settings.whatsappNumber);
        }
      } catch (err) {
        // console error optionally
      }
    };
    fetchNumber();
  }, []);

  const handleClick = () => {
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <Tooltip title="WhatsApp ile iletişim kurun" placement="left">
      <Fab
        color="success"
        aria-label="WhatsApp"
        onClick={handleClick}
        sx={{
          position: 'fixed',
          bottom: 100,
          right: 20,
          zIndex: 1000,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          '&:hover': {
            transform: 'scale(1.1)',
            boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)',
          },
          transition: 'all 0.3s ease',
        }}
      >
        <WhatsApp />
      </Fab>
    </Tooltip>
  );
};

export default WhatsAppButton; 